import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchActivateFleetAudioSchema, patchAudioSchema } from '../../services/AudioSchemaService';
import { AudioSchema, AudioSchemaActivateFleetRequest } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchema, Error, AudioSchemaActivateFleetRequest>;

function usePatchActivateFleetAudioSchema(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchActivateFleetAudioSchema, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchActivateFleetAudioSchema;
